import React, {Fragment} from 'react';
import { withRouter} from "react-router-dom";
import { compose } from "redux";
import { connect } from "react-redux";
import { Formik, FieldArray  } from 'formik';
import styled from 'styled-components';
import { Button, Toolbar, Grid, Table, TableHead,TableBody, TableRow, TableCell} from '@material-ui/core';
import { withStyles } from "@material-ui/core/styles";
import Check from "@material-ui/icons/Check";
import _ from 'lodash';

import { getCompanyCreditRatings, updateCompanyCreditRatings } from "store/state/creditRatings";

import SimpleConfirmDialog from 'components/Global/ConfirmationDialogs/SimpleConfirmDialog';
import {CancelButton, SecondaryButton} from 'components/Global/Buttons';

import { RatingSelect } from './RatingSelect';

const styles = theme => ({
    headerRow: {
      background: '#f9f9f9',
      height:'40px'
    },
    startCell: {
      padding: '8px'
    },
    companyNameCell: {
      width:'15%',
    },    
    ratingCell: {
        padding: '8px',
        width: '150px',
      }
  });
  
const FormBody = styled(Grid)`
  &&& {
      padding:15px;
  }
`
const SpacerDiv = styled.div`
  height: 350px;
`;

const FormWrapper = styled.div`
  position:relative;
  overflow:auto;
  max-height:calc(100vh - 216px);
  margin-left:16px;   
`
const StyledTableHead = styled(TableHead)`
  && {
    border-bottom: 3px solid #eee;
  }
`
const HeaderCell = styled(TableCell)`
  &&& {
    color:#202020;    
    font-size:14px;  
  }
`
const Title = styled.div`
font-size:24px;
color: #333333;
`
const Spacer = styled.div`
flex-grow:1;
`

let selectStyles = {    
    container: (provided, state) => ({
      ...provided,
      borderBottom: '1px solid #2196F3',
      transition: 'border 0.1s',
      '&:hover': {
        cursor: 'pointer',
        borderBottom: '1px solid #43A8FF'
      },
      padding: '0'
    }),
    indicatorSeparator: (provided, state) => ({
      display:'none'
    }),
    placeholder: (provided, state) => ({
      color: '#999',      
      padding: 0,
      position:'absolute',
      top: '9px'
    }),
    control: (provided, state) => ({
      ...provided,
      boxShadow: 'none',
      border:'none',
      padding: 0      
    })
  }

class CompanyCreditRatings extends React.Component {
    state ={        
        isCancelModalOpen:false,
        initialValues: []
    }

    constructor(props){
        super(props);
        this.formik = React.createRef();
       }

       componentDidMount() {
           this.props.getCompanyCreditRatings();
        }
         
        componentDidUpdate(prevProps) {
            const {creditRatingsDetail} = this.props;
            const {creditRatingsDetail: prevedgeDetails} = prevProps;
            
            if(creditRatingsDetail !== prevedgeDetails && creditRatingsDetail) {
                let newInitialValues = _.cloneDeep(creditRatingsDetail);
                this.setState({initialValues: newInitialValues});
            }
        }
        
        renderButtons = () => {
            return (
            <Fragment>
                <CancelButton onClick={this.openCancelModal}/>
                <SecondaryButton onClick={this.save}>
                  <Check />
                  <div>Save and Run Credit Rating Comparison</div>    
                </SecondaryButton>  
            </Fragment>
            );            
          }

       save = () => this.setState(
        { callbackToCall: () => {} },
        () => this.formik.current.handleSubmit()
       )

       openCancelModal = () => this.setState({isCancelModalOpen: true})    
       closeCancelModal = () => this.setState({isCancelModalOpen: false})


       render() {
        const { isCancelModalOpen, initialValues } = this.state;
        const {creditRatingsDetail, ancillary, classes} = this.props;
        let currentSelectStyles = {...selectStyles};

        if(!creditRatingsDetail || creditRatingsDetail.length === 0 || !ancillary) 
          return <Fragment>No Hedge Providers Found</Fragment>;

        return (
            <Fragment>
                <Toolbar disableGutters>
                    <Title>Hedge Provider Ratings</Title>
                    {this.renderButtons()}
                    <Spacer/>
                </Toolbar>
                    
                <Grid container alignItems="flex-start" justify="flex-start" direction="row">                    
                    <Grid item xs={12} lg={12}>
                      <FormWrapper >
                        <Formik
                                ref={this.formik}                                
                                enableReinitialize
                                validateOnChange={true}
                                initialValues={initialValues}                
                                onSubmit={(values,{setSubmitting}) => {
                                    this.props.updateCompanyCreditRatings(values);
                                    setSubmitting(false);
                                  }}                                
                                render={({values,errors,status,touched, isSubmitting,handleChange, handleBlur,handleSubmit, setFieldValue}) => {           
                                    const hasCompanies = values.length > 0;
                                    return (<FormBody container item xs={12} lg={12}>                                        
                                                {hasCompanies && <Table padding='none'>
                                                    <StyledTableHead>
                                                    <TableRow classes={{root:classes.headerRow}}>
                                                        <HeaderCell classes={{root: classes.companyNameCell}}>Hedge Provider</HeaderCell>
                                                        <HeaderCell >S&P Short</HeaderCell>
                                                        <HeaderCell >S&P Long</HeaderCell>
                                                        <HeaderCell >Moody's Short</HeaderCell>
                                                        <HeaderCell >Moody's Long</HeaderCell>
                                                        <HeaderCell >Fitch Short</HeaderCell>             
                                                        <HeaderCell >Fitch Long</HeaderCell>
                                                    </TableRow>
                                                    </StyledTableHead>
                                                    
                                                      <FieldArray
                                                      name="companyCreditRatings"
                                                      render = {arrayHelpers => (
                                                        <TableBody>
                                                          {values.map((companyCreditRating, index) => {
                                                                return (
                                                                        <TableRow key={companyCreditRating.id}>                                                                          
                                                                          <TableCell classes={{root: classes.companyNameCell}}>{values[index].company.name}</TableCell>                                                            
                                                                          <TableCell classes={{root: classes.ratingCell}}><RatingSelect placeholder="S&P Short"     fieldName="spShortDowngradeId"     options={ancillary.spShortDowngrades} values={values} index={index} currentSelectStyles={currentSelectStyles} arrayHelpers={arrayHelpers} /></TableCell>
                                                                          <TableCell classes={{root: classes.ratingCell}}><RatingSelect placeholder="S&P Long"      fieldName="spLongDowngradeId"      options={ancillary.spLongDowngrades} values={values} index={index} currentSelectStyles={currentSelectStyles} arrayHelpers={arrayHelpers} /></TableCell>                                                                          
                                                                          <TableCell classes={{root: classes.ratingCell}}><RatingSelect placeholder="Moody's Short" fieldName="moodysShortDowngradeId" options={ancillary.moodysShortDowngrades} values={values} index={index} currentSelectStyles={currentSelectStyles} arrayHelpers={arrayHelpers} /></TableCell>                                                                       
                                                                          <TableCell classes={{root: classes.ratingCell}}><RatingSelect placeholder="Moody's Long"  fieldName="moodysLongDowngradeId"  options={ancillary.moodysLongDowngrades} values={values} index={index} currentSelectStyles={currentSelectStyles} arrayHelpers={arrayHelpers} /></TableCell>                                                                       
                                                                          <TableCell classes={{root: classes.ratingCell}}><RatingSelect placeholder="Fitch Short"   fieldName="fitchShortDowngradeId"  options={ancillary.fitchShortDowngrades} values={values} index={index} currentSelectStyles={currentSelectStyles} arrayHelpers={arrayHelpers} /></TableCell>                                                                   
                                                                          <TableCell classes={{root: classes.ratingCell}}><RatingSelect placeholder="Fitch Long"    fieldName="fitchLongDowngradeId"   options={ancillary.fitchLongDowngrades} values={values} index={index} currentSelectStyles={currentSelectStyles} arrayHelpers={arrayHelpers} /></TableCell>
                                                                      </TableRow>
                                                            )})}
                                                        </TableBody>
                                                      )}
                                                      />
                                                </Table>}
                                            </FormBody>
                                          )}}/>                                             
                        <SpacerDiv></SpacerDiv>                
                        </FormWrapper>                        
                    </Grid>               
                </Grid>
                <SimpleConfirmDialog 
                    title="Confirm Cancel"
                    message="You are about to cancel all of your changes. Are you sure you want to do this?"
                    noText="NO"
                    yesText="YES, CANCEL"
                    modalOpen={isCancelModalOpen}
                    handleNo={this.closeCancelModal}
                    handleYes={() => {
                        this.props.getCompanyCreditRatings();
                        this.setState({isCancelModalOpen:false})
                    }} />
          </Fragment>
          );
        
       }
}

function mapStateToProps({creditRatings}) { 
    return {
        creditRatingsDetail: creditRatings.companyCreditRatings ? creditRatings.companyCreditRatings.companies : null,
        ancillary: creditRatings.companyCreditRatings ? creditRatings.companyCreditRatings.ancillary : null,
    }
 }

export default compose(
    withRouter,
    connect( mapStateToProps, 
            { 
              getCompanyCreditRatings,
              updateCompanyCreditRatings 
            }
           ),
    withStyles(styles))(CompanyCreditRatings);